import React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Avatar, AvatarProps } from './Avatar';
import { Option } from '@im/ui-lib/SelectOption';
import { SelectChangeEvent } from '@mui/material/Select';
import { useTranslate } from '@im/react-localization';
import SelectOption from 'src/components/SelectOption';

type Props = {
  AvatarProps: AvatarProps;
  availableLanguages: string[];
  countryOptions?: Option[];
  'data-testid'?: string;
  onCountryChange?: (
    event: SelectChangeEvent<unknown>,
    child: React.ReactNode
  ) => void;
  onLanguageChange?: (
    event: SelectChangeEvent<unknown>,
    child: React.ReactNode
  ) => void;
  selectedCountry?: string;
  selectedLanguage?: string;
  showAvatar?: boolean;
};

export function HeaderUserActions(props: Readonly<Props>) {
  const {
    AvatarProps,
    countryOptions,
    'data-testid': testid = 'required',
    onCountryChange,
    selectedCountry,
    showAvatar,
  } = props;
  const translate = useTranslate();

  return (
    <RootStack alignItems="center" direction="row" spacing="0.571rem">
      {props.availableLanguages?.length > 1 && (
        <SelectOption
          MenuProps={{
            PaperProps: {
              sx: {
                '& .MuiList-root': {
                  minWidth: '148px',
                },
              },
            },
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            transformOrigin: { horizontal: 'right', vertical: 'top' },
          }}
          data-testid="gds-language-select"
          onChange={props.onLanguageChange}
          options={props.availableLanguages?.map((code) => ({
            label: translate(`Common.Lang${code.split('-')[0].toUpperCase()}`, {
              culture: code.split('-')[1],
            }),
            value: code,
          }))}
          value={props.selectedLanguage}
        />
      )}
      {countryOptions && (
        <SelectOption
          MenuProps={{
            PaperProps: {
              sx: {
                '& .MuiList-root': {
                  minWidth: '148px',
                },
              },
            },
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            transformOrigin: { horizontal: 'right', vertical: 'top' },
          }}
          data-testid="gds-country-select"
          onChange={onCountryChange}
          options={countryOptions}
          value={selectedCountry}
        />
      )}
      {showAvatar && <Avatar {...AvatarProps} data-testid={testid} />}
    </RootStack>
  );
}

const RootStack = styled(Stack)(({ theme }) => ({
  '& .MuiBadge-anchorOriginTopRightRectangular.MuiBadge-badge': {
    borderRadius: '8px',
    fontSize: '10px',
    height: '16px',
    left: '7px',
    lineHeight: '14px',
    top: '-2px',
    width: '20px',
  },
  '& .iconButton': {
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
}));
